import React, {useEffect, useState} from 'react';
import {ArrowLeftOutlined,SaveOutlined,DeleteOutlined} from "@ant-design/icons";
import print from "../../../../../../icons/print.png";
import pdf from "../../../../../../icons/pdf.png";
import excel from "../../../../../../icons/excel.png";
import {seasonMonths} from "../../../../../../components/functions/Month";
import axios from "axios";
import {header} from "../../../../../../components/api/Header";
import {add_func} from "../../../../../../components/functions/Mathematik";
import {user_data} from "../../../../../../components/functions/usr";
import {NavLink} from "react-router-dom";
import swal from "sweetalert";
import { getEnv } from "../../../../../../lib/env";
function Add() {
    if(!user_data() || user_data().region_id != 1){
        window.location = '/limit/ptn/dekadalik'
    }
    const [hasData, setHasData] = useState(0)
    const [year, setYear] = useState('')
    const [lyear, setLyear] = useState(year)
    const [season, setSeason] = useState('veg')
    const [data, setData] = useState([])
    useEffect(()=>{
        const fetchData = async () => {
            const res = await axios.get(getEnv('REACT_APP_BASE_URL')+"/v1/region/limitptn/dekada?year="+year+"&season="+season, header())
                .catch(e=>{
                    console.log("Xato",e)
                    alert("Server bilan aloqa yo'q")
                })
            if(res){
                setData(res.data.data)
                setHasData(res.data.hasData)
            }
        }
        if(year){
            fetchData()
        }
    },[year,season])
    const setHandler = (v,i,d,t) => {
        let dat = [...data]
        if(dat[i]){
            if(dat[i][t]){
                dat[i][t][d] = v
                setChanged(true)
            }
        }
        setData(dat)
    }
    const [changed, setChanged] = useState(false)
    const doIt = async (action) => {
        const res = await axios.post(getEnv('REACT_APP_BASE_URL')+"/v1/region/limitptn/"+action,{data,year,season}, header())
            .catch(e=>{
                console.log("Xato",e)
                alert("Server bilan aloqa yo'q!")
            })
        if(res){
            if(res.data.status == 200){
                swal("Muvaffaqiyalti", res.data.message, 'success')
                window.location = "/limit/ptn/dekadalik"
            }else{
                swal("Xato", res.data.message, 'error')
            }
        }
    }
    return (
        <>
            <div className="table-content-top">
                <div className="table-top-left d-flex align-items-center">
                    <NavLink to="/limit/ptn/dekadalik" className="btn btn-sm btn-outline-primary d-flex align-items-center">
                        <ArrowLeftOutlined />&nbsp;&nbsp;&nbsp;Qaytish
                    </NavLink>
                    &nbsp;&nbsp;&nbsp;
                    {
                        changed ? <button className="btn btn-sm btn-outline-primary d-flex align-items-center" onClick={()=>doIt('save')}>
                            Saqlash &nbsp;&nbsp;&nbsp;<SaveOutlined />
                        </button> :null
                    }
                    {
                        hasData ? <button className="btn btn-sm btn-outline-danger d-flex align-items-center" onClick={()=>doIt('delete')}>
                            O'chirish &nbsp;&nbsp;&nbsp;<DeleteOutlined />
                        </button> :null
                    }

                </div>
                <ul className="table-top-right">

                    <li className="d-flex align-items-center">
                        <input type="number" className="form-control form-control-sm" min={2015} max={parseInt(new Date().toISOString().slice(0,4))+2} value={lyear} onChange={e=>setLyear(e.target.value)}/>
                        &nbsp;&nbsp;&nbsp;
                        <button className="btn btn-sm btn-outline-primary" onClick={()=>setYear(lyear)}>Ok</button>
                    </li>
                    <li>
                        <select className="form-select form-select-sm" onChange={e=>setSeason(e.target.value)} value={season}>
                            <option value="veg">Sug'orish mavsumi</option>
                            <option value="noveg">Nosug'orish mavsumi</option>
                        </select>
                    </li>
                </ul>
            </div>
            <div className="table-responsive tableFixHead">
                <table className="table table-bordered table-style">
                    <thead>
                    <tr>
                        <th colSpan={22}>Qoraqalpog‘iston Respublikasi va viloyatlarga {year}-yil {season == 'noveg' ? 'no' :null}sug‘orish mavsumida ajratilgan suv olish limiti</th>
                    </tr>
                    <tr>
                        <th rowSpan={2} scope="col">№</th>
                        <th rowSpan={2} scope="col">Hududlar nomi</th>
                        <th rowSpan={2} scope="col">Ko‘rsatkichlar</th>
                        {
                            seasonMonths(season).map((s,i)=>{
                                return <th key={i} colSpan={3}>{s}</th>
                            })
                        }
                    </tr>
                    <tr>
                        <th scope="col">I</th>
                        <th scope="col">II</th>
                        <th scope="col">III</th>
                        <th scope="col">I</th>
                        <th scope="col">II</th>
                        <th scope="col">III</th>
                        <th scope="col">I</th>
                        <th scope="col">II</th>
                        <th scope="col">III</th>
                        <th scope="col">I</th>
                        <th scope="col">II</th>
                        <th scope="col">III</th>
                        <th scope="col">I</th>
                        <th scope="col">II</th>
                        <th scope="col">III</th>
                        <th scope="col">I</th>
                        <th scope="col">II</th>
                        <th scope="col">III</th>
                    </tr>
                    </thead>
                    {
                        data.length > 0?
                            data.map((d,i) => {
                                return <tbody key={i}>
                                <tr>
                                    <th rowSpan={(d.region_id>=4&&d.region_id<=6)?4:3} className="vertical-middle">{i+1}</th>
                                    <th rowSpan={(d.region_id>=4&&d.region_id<=6)?4:3} className="vertical-middle">{d.name}</th>
                                    <th><b>jami</b></th>
                                    {
                                        Array(18).fill().map((p,ind)=>{
                                            return <th key={ind}>{
                                                (d.region_id>=4&&d.region_id<=6)
                                                ?add_func(add_func(d.ste['d'+(ind+1)],d.sugorish['d'+(ind+1)]),d.shj_zarafshondan?d.shj_zarafshondan['d'+(ind+1)]:0)
                                                :add_func(d.ste['d'+(ind+1)],d.sugorish['d'+(ind+1)])
                                            }</th>
                                        })
                                    }
                                </tr>
                                <tr>
                                    <th>sh.j. sug‘orishga</th>
                                    {
                                        Array(18).fill().map((p,ind)=>{
                                            return <th key={ind} className="inserttr">
                                                <input type="number" className="insertable" value={d.sugorish['d'+(ind+1)]} onChange={e=>setHandler(e.target.value,i,'d'+(ind+1),'sugorish')}/>
                                            </th>
                                        })
                                    }
                                </tr>
                                <tr>
                                    <th><i>STE va boshqalar</i></th>
                                    {
                                        Array(18).fill().map((p,ind)=>{
                                            return <th key={ind} className="inserttr">
                                                <input type="number" className="insertable" value={d.ste['d'+(ind+1)]} onChange={e=>setHandler(e.target.value,i,'d'+(ind+1),'ste')}/>
                                            </th>
                                        })
                                    }
                                </tr>
                                {
                                    (d.region_id>=4&&d.region_id<=6)?
                                        <tr>
                                            <th><i>sh.j. Zarafshon daryosidan</i></th>
                                            {
                                                Array(18).fill().map((p,ind)=>{
                                                    return <th key={ind} className="inserttr">
                                                        <input type="number" className="insertable" value={d.shj_zarafshondan?d.shj_zarafshondan['d'+(ind+1)]:0} onChange={e=>setHandler(e.target.value,i,'d'+(ind+1),'shj_zarafshondan')}/>
                                                    </th>
                                                })
                                            }
                                        </tr>:null
                                }
                                </tbody>
                            })
                            :null
                    }
                </table>
            </div>
        </>
    );
}

export default Add;

